/**
 * Universal random helpers backed by the Web Crypto API — available on
 * Node ≥18 and every modern browser. Avoids importing `node:crypto` so the
 * same source compiles for both the Node and browser bundles.
 */

export function randomBytes(size: number): Uint8Array {
  const buf = new Uint8Array(size);
  globalThis.crypto.getRandomValues(buf);
  return buf;
}

export function randomHex(size: number): string {
  const buf = randomBytes(size);
  let hex = "";
  for (let i = 0; i < buf.length; i++) {
    hex += buf[i].toString(16).padStart(2, "0");
  }
  return hex;
}
